import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISchedulesTableInitialState, IScheduleTable, IVehicle } from '@types';

import { initialSchedules } from './initialState';

export const schedulesSlice = createSlice({
    name: 'schedules',
    initialState: initialSchedules(),
    reducers: {
        setSchedules(state: ISchedulesTableInitialState, action: PayloadAction<IScheduleTable>) {
            state.schedulesTableList = state.schedulesTableList ? [...state.schedulesTableList, action.payload] : [action.payload];
        },

        setVehicle(state: ISchedulesTableInitialState, action: PayloadAction<IVehicle>) {
            state.vehicle = action.payload;
        },

        deleteScheduleTable(state: ISchedulesTableInitialState) {
            state.schedulesTableList = [];
        },
    },
});
